export default "__VITE_ASSET__41529c06__"